import Cookies from "js-cookie";
import { VerifyJWT } from "core-web/libs/GrebbCommerceAPI/Products";
import getQueryParams from "core-web/utils/getQueryParams";

const getSpecialPriceData = async (variants, partNo, location, url, applicationId, ssrCookies = {}) => {
    const specialPriceHash = getQueryParams(location)?.pr2;
    const partNoWithCookie =
        variants.find((variant) => {
            const cookieName = `specialPrice-${variant.part_no}`;
            return ssrCookies?.[cookieName] ?? Cookies.get(cookieName);
        })?.part_no || partNo;
    const cookie = ssrCookies?.[`specialPrice-${partNoWithCookie}`] ?? Cookies.get(`specialPrice-${partNoWithCookie}`);

    if (!!specialPriceHash) {
        try {
            const specialPriceData = await VerifyJWT(specialPriceHash, "api", url, applicationId);
            const { p: priceIncVat, o: objectId } = specialPriceData || {};
            const discountExpirationDate = new Date(Date.now() + 24 * 60 * 60 * 1000); // Now + 24hrs
            const discountTimeStamp = Math.floor(discountExpirationDate.getTime() / 1000);

            return {
                discountPriceIncVat: priceIncVat,
                productPartNo: objectId,
                discountExpirationDate,
                discountTimeStamp,
            };
        } catch (e) {
            return null;
        }
    } else if (cookie) {
        return typeof cookie === "string" ? JSON.parse(cookie) : cookie;
    }

    return null;
};

export default getSpecialPriceData;
